var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1889 9.53563C37.074 21.1808 25.6782 31.3176 19.1161 35.2251C18.8073 35.4089 18.4236 35.1822 18.4236 34.8229V31.0946C18.4236 30.8702 18.2599 30.6763 18.0404 30.6295C7.20313 28.3208 5.15915 21.775 5.01611 18.1951C4.56969 7.02222 13.5076 3.00001 18.4236 3C25.1111 2.99998 28.5502 7.15209 30.1889 9.53563Z",
    stroke: "#8A96A3",
    strokeWidth: 3.29923
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment_icon.907684098d35d13073672e618b070666.svg";
export { ForwardRef as ReactComponent };